
document.addEventListener('DOMContentLoaded', function() {

  const videoItems = document.querySelectorAll('.video_item');
  const closeButtons = document.querySelectorAll('.close-video');
  const videoPopups = document.querySelectorAll('[id*="-video_list_"]');

  videoItems.forEach(item => {
    item.addEventListener('click', function(event) {
      event.preventDefault();

      const videoPopup = this.nextElementSibling;

      if (videoPopup && videoPopup.matches('[id*="-video_list_"]')) {
        const videoElement = videoPopup.querySelector('video');

        videoPopup.classList.add('active-video-popup');
        
        if (videoElement) {
          videoElement.play();
        }
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      const videoPopup = this.closest('[id*="-video_list_"]');
      const videoElement = videoPopup.querySelector('video');

      videoPopup.classList.remove('active-video-popup');

      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0; 
      }
    });
  });

  videoPopups.forEach(popup => {
    popup.addEventListener('click', function(event) {
      if (event.target === this) {
        const videoElement = this.querySelector('video');

        this.classList.remove('active-video-popup');

        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0; 
        }
      }
    });
  });

  const cart_term_of_condition = document.querySelector('.wt-cart__footer__body #cart_term_of_condition');
  if(cart_term_of_condition){
    const btnCartDrawerCheckout = document.querySelectorAll('#CartDrawer-Checkout');
    console.log(btnCartDrawerCheckout);
    if(btnCartDrawerCheckout){
      btnCartDrawerCheckout.forEach(button => {
        button.addEventListener('click', function(event) {
            event.preventDefault();
            
            if (cart_term_of_condition.checked) {
              window.location.href = "/checkout";
            } else {
              alert("Please agree to the terms and conditions before checkout!");
              cart_term_of_condition.focus();
            }
        });
      });
    }
  }

  document.addEventListener("cart-drawer:refresh", (e) => {
    console.log('cart-drawer:refresh');
  });

  const mincart_popup_container = document.querySelector('.mincart-popup');
  console.log(mincart_popup_container);
  if(mincart_popup_container){
    const contactButton = `<a href="/pages/contact" class="mincart_btn_contact_us">CONTACT US</a>`;
    setTimeout(function() {
       $('#mincart-button').before(contactButton);
    }, 1000);
    
  }
  
  
});

/*
document.addEventListener('click', function (e) {
  console.log(e.target);
  if (e.target.closest('svg')) {
    console.log('Clicked an SVG or its child element');
    return;
  }

  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');

  if (href && href !== '#' && !href.startsWith('#')) {
    window.location.href = href;
  } else {
    e.preventDefault();
  }
});
*/

document.addEventListener('click', function (e) {
  const link = e.target.closest('a');
  if (!link) return;

  const href = link.getAttribute('href');

  if (!href || href === '#' || href.startsWith('#')) {
    e.preventDefault();
    return;
  }

  if (link.target === '_blank') {
    window.open(href, '_blank', 'noopener,noreferrer');
    e.preventDefault();
    return;
  }

  window.location.href = href;
});











